/**
 * ============================================================================
 * AuditLog 模块 - 常量定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义枚举标签映射（中文显示）
 * - 定义权限常量
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/SystemAuditLog.php (getActionTextAttribute方法)
 * 
 * ⚠️ 注意事项：
 * - 标签对象命名：{MODULE}_{ENUM}_LABELS（全大写）
 * - 权限常量命名：{MODULE}_PERMISSIONS（全大写）
 * - 使用 `as const` 保证类型推断
 * - 枚举标签的 key 必须与 enums.ts 中的枚举值对应
 * 
 * 🔄 更新时机：
 * - enums.ts 新增枚举值时（同步新增标签）
 * - 后端权限定义变化时
 * - 中文标签需要修改时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Models/SystemAuditLog.php
 * 2. 找到 getActionTextAttribute 方法中的 $actions 数组
 * 3. 检查本文件的 LABELS 对象是否包含所有映射
 * 4. 检查中文标签是否与后端一致
 * 
 * @module types/audit-log/constants
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

import { AuditAction } from './enums'

/**
 * 审计操作类型标签映射
 * 
 * 对应后端 SystemAuditLog::getActionTextAttribute() 方法中的映射
 */
export const AUDIT_ACTION_LABELS = {
  [AuditAction.CREATE]: '创建',
  [AuditAction.UPDATE]: '修改',
  [AuditAction.DELETE]: '删除',
  [AuditAction.VIEW]: '查看',
  [AuditAction.EXPORT]: '导出',
  [AuditAction.IMPORT]: '导入',
  [AuditAction.APPROVE]: '审批',
  [AuditAction.REJECT]: '驳回',
  [AuditAction.SUBMIT]: '提交',
  [AuditAction.CANCEL]: '取消',
} as const

/**
 * ⚠️ 审计日志权限常量已迁移至统一权限管理
 * 
 * 请从 @bayes-mes/shared 导入标准权限常量：
 * - PERM_SYSTEM_AUDIT_VIEW
 * - PERM_SYSTEM_AUDIT_EXPORT
 * 
 * @deprecated 请使用 constants/api-permissions.ts 中的权限常量
 * @see bayes-mes-shared/constants/api-permissions.ts
 */

